import * as React from 'react'
import { ValueContainerProps, components } from 'react-select'
import { TSkillOption } from '../skill-select.types'

export const ValueContainer = (
  props: ValueContainerProps<TSkillOption, true>
) => <components.ValueContainer {...props} className="p-3" />
